import classNames from "@/utils/classNames";
import { InputHTMLAttributes, ReactNode, useState } from "react";

type RadioProps = {
    label?: ReactNode;
    onChange?: (e: boolean) => void;
    dataTestId?: string;
};

export default function Radio({
    className = "",
    label,
    dataTestId,
    ...props
}: Omit<InputHTMLAttributes<HTMLInputElement>, "onChange"> & RadioProps) {
    const [isChecked, setIsChecked] = useState(props.defaultChecked);

    const handleToggle = () => {
        if (props.disabled) return;
        setIsChecked(!isChecked);
        props.onChange?.(!isChecked);
    };

    return (
        <div
            className={classNames(
                "flex",
                props.disabled ? "cursor-not-allowed" : "cursor-pointer",
            )}
            onClick={handleToggle}
            onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    handleToggle();
                }
            }}
            data-testid={dataTestId ?? "option-selector"}
            role="radio"
            aria-checked={props.checked ?? isChecked}
            tabIndex={props.disabled ? -1 : 0}
        >
            <input
                {...props}
                type="radio"
                className={classNames(
                    "h-5 w-5 cursor-pointer rounded-full text-brand-red accent-brand-red focus:ring-transparent disabled:cursor-not-allowed disabled:bg-brand-lightGray",
                    className,
                )}
                checked={props.checked ?? isChecked}
                onChange={() => {}}
            />
            {label && (
                <span
                    className={classNames(
                        "-mt-[2.5px] ms-2",
                        props.disabled
                            ? "cursor-not-allowed"
                            : "cursor-pointer",
                    )}
                >
                    {label}
                </span>
            )}
        </div>
    );
}
